/**
 * Fuente única de verdad para las URLs del backend.
 *
 * VITE_API_URL se resuelve en tiempo de build (Vite), no en runtime:
 * en Coolify debe pasarse como build arg, no como variable del contenedor.
 *
 * Se acepta con o sin el sufijo "/api", y también en forma relativa
 * ("/api") cuando el frontend y el backend comparten dominio.
 */
const DEFAULT_API_URL = 'http://localhost:4000/api';

const raw = (import.meta.env.VITE_API_URL || '').trim().replace(/\/+$/, '');
const base = raw || DEFAULT_API_URL;

/** Base de la API, siempre terminada en "/api". Ej: https://api.ejemplo.com/api */
export const API_URL = /\/api$/.test(base) ? base : `${base}/api`;

/** Origen del servidor, sin "/api". Para Socket.IO y enlaces directos. */
export const SERVER_URL = API_URL.replace(/\/api$/, '') || window.location.origin;
